import { MutationTree } from 'vuex';
import { OrderState } from '@/store/modules/order/state';
import ActionTypes from '@/constants/action-types';
import { OrderReceiptModel } from '@/models/OrderReceiptModel';

const mutations: MutationTree<OrderState> = {

  [ActionTypes.GetOrderReceipt](state: OrderState, orderReceipt: OrderReceiptModel) {
    state.orderReceipt = orderReceipt;
  },

};

export default mutations;
